export enum RadiusMeasurement {
  MILE = "MILE",
  KILOMETER = "KILOMETER",
}



// WEBPACK FOOTER //
// ./src/models/resource-management/volunteers/radius-measurement.ts